import { Text } from '@yes.technology/react-toolkit'
import { TextSliderCard as TextSliderCardContainer } from './TextSlider.styles'
import { TextSliderObject } from './TextSlider.types'

const TextSliderCard = ({ des, complement, obs }: TextSliderObject) => {
  return (
    <TextSliderCardContainer>
      <Text as='header' variant='bordertext-05'>
        {obs}
      </Text>
      <Text as='h2' variant='content-emphasis-07'>
        {des}
      </Text>
      {complement && (
        <Text as='p' variant='content-06'>
          {complement}
        </Text>
      )}
    </TextSliderCardContainer>
  )
}

export default TextSliderCard
